import axios from 'axios'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'
import config from '@/config'

const service = axios.create({
  baseURL: config.baseURL,
  timeout: config.timeout
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    config.withCredentials = true
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res && res.code !== undefined && res.code !== 0 && res.code !== 200) {
      Message.error(res.message || '请求失败')
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    const status = error.response?.status
    const silentError = Boolean(error?.config?.silentError)
    // 鉴权类错误始终提示（避免探针类请求 silentError 盖住「未登录」）
    if (status === 401) {
      Message.error('登录已过期，请重新登录')
    } else if (status === 403) {
      Message.error(error.response?.data?.message || '无权限')
    } else if (!silentError) {
      if (status && status >= 500) {
        Message.error(error.response?.data?.message || '服务器错误')
      } else if (error.response) {
        Message.error(error.response?.data?.message || error.message || '请求失败')
      }
    }
    return Promise.reject(error)
  }
)

export default service
